import {
  Checkbox,
  FormControlLabel,
  Link,
  SxProps,
  Theme,
} from "@mui/material";

export interface ConfidentialityConsentProps {
  agreementChecked: boolean;
  setAgreementChecked: (value: boolean) => void;
  sx?: SxProps<Theme>;
}

export function ConfidentialityConsent(
  props: ConfidentialityConsentProps,
): JSX.Element {
  const { agreementChecked, setAgreementChecked, sx } = props;
  return (
    <FormControlLabel
      sx={{ ...sx }}
      control={
        <Checkbox
          onChange={() => setAgreementChecked(!agreementChecked)}
          checked={agreementChecked}
        />
      }
      label={
        <Link
          tabIndex={-1}
          target="_blank"
          rel="noopener noreferrer"
          href="/personal-data-policy"
          underline="always"
          color="secondary"
          onClick={(event) => event.stopPropagation()}
        >
          С политикой конфиденциальности при хранении и обработке персональных
          данных в соответствии с ФЗ 152 согласен
        </Link>
      }
    />
  );
}
